<mat-list class="process-quick-menu">
  @for (item of menu; track item.name) {
    <mat-list-item>
      <a (click)="item.action()"
        [routerLink]="item.link"
        [textContent]="item.name"
      mat-menu-item></a>
    </mat-list-item>
  }
</mat-list>
